export default __webpack_public_path__ + "static/media/nft-feature.6bd04d20.png";